// 捕捉projectId为null的接口枚举数组
export const catchApiList = [
  '/api/v1/people/getProjectMember/',
  '/api/v1/project/projectStatus/',
  '/api/v1/project/accessibleModule/',
  '/api/v1/project/dealComplexity/getQuesStatusAndSectionLevel/',
];

// 可编辑表格单元格的类型，如：
export const EDIT_TABLE_COLUMNS_TYPE = {
  // RICH_EDITOR: 'RICH_EDITOR', // 富文本，暂时不需要，先不拓展
  SELECT: 'SELECT', // 选择框
  INPUT: 'INPUT', // 输入框
  NUMBER_INPUT: 'NUMBER_INPUT', // 数字输入框
  DATE_PICKER: 'DATE_PICKER', // 日期选择器
  GanttCombCell: 'GanttCombCell', // for gantt chart first cell
  GanttDurationCell: 'GanttDurationCell', // for gantt chart duration cell
  OrgCombCell: 'OrgCombCell', // for org chart first cell
};

export const WIDGET_CHART_TYPE = {
  ORG_CHART: 'org',
  GANTT_CHART: 'gantt',
};

export const WIDGET_GANTT_CHART_STATUS = {
  ACTIVITY: 'Activity',
  MILESTONE: 'Milestone',
};

// export const WIDGET_GANTT_CHART_TYPE = {
//     AT_RISK: 'AT RISK',
//     DELAYED: 'DELAYED',
//     NOT_STARTED: 'NOT STARTED',
//     ON_TRACK: 'ON TRACK',
// };
